/**
 * B 后台统一时间展示（本地时区）：YYYY-MM-DD HH:mm:ss
 * 避免 RFC3339（含 T、Z、微秒）直接展示导致运营看不懂。
 *
 * @param {string|number|Date|null|undefined} value ISO 字符串、时间戳(ms)、Date
 * @returns {string}
 */
export function formatDateTime(value) {
  if (value === null || value === undefined || value === '') return '-'
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) {
    return typeof value === 'string' ? value : '-'
  }
  const y = d.getFullYear()
  const mo = String(d.getMonth() + 1).padStart(2, '0')
  const da = String(d.getDate()).padStart(2, '0')
  const h = String(d.getHours()).padStart(2, '0')
  const mi = String(d.getMinutes()).padStart(2, '0')
  const s = String(d.getSeconds()).padStart(2, '0')
  return `${y}-${mo}-${da} ${h}:${mi}:${s}`
}
